import { cancelPreBooking } from "../../../app/api/cancelPreBooking";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";

class CancelPreBookingAction extends BaseAction<void, { bookingId: string }> {
  override async run(): Promise<void> {
    try {
      const { bookingId } = this.params!;

      if (!bookingId) {
        console.error("CancelPreBookingAction: bookingId is required");
        return;
      }

      const response: any = await cancelPreBooking(bookingId);
      if (response.status === 'ok' && response.answer) {
        updateRecoilState('bookingResponseAtom', null);
      }
    } catch (error) {
      console.error("Error in CancelPreBookingAction:", error);
    }
  }
}

export const cancelPreBookingAction = new CancelPreBookingAction();
